<script setup>
import { formatPhone } from "@/utils/strings"

const props = defineProps({
  customerObject: {
    type: Object,
  },
})

const firstName = !isEmpty(props.customerObject?.name) ? props.customerObject?.name +  ' ' : ''
const lastName =  !isEmpty(props.customerObject?.surname) ?  props.customerObject?.surname : ''
const phone =  props.customerObject?.phone || ''
</script>

<template>
  <div v-if="firstName || lastName || phone">
    <span>
      <VIcon icon="ri-user-line" />
      {{ firstName }} {{ lastName }}
    </span>
    <span
      v-if="phone"
      class="ml-1"
    >
      ({{ formatPhone(phone) }})
    </span>
  </div>
</template>
